// Centralized Captec company configuration.
// Mandatory logo rule: render ONLY the logo image, never the word "Captec" beside it.
export const companyConfig = {
  name: "Captec",
  logoUrl: "/assets/cosmos/captec-orbit-logo.png",
  logoAlt: "Captec",
  tagline: "Procesadora regional de medios de pago para instituciones financieras en Latinoamérica",
  serviceDeskUrl: "https://servicedeskcaptec.atlassian.net/servicedesk/customer/portal/5",
  // TODO_LINKEDIN_URL_REQUIRES_CLIENT_CONFIRMATION
  linkedinUrl: null,
  yearsExperience: 15,
  yearsEcuador: 15,
};
